import React from 'react';
import { useSelector } from 'react-redux';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { Card } from 'antd';
import './VisitorWeekGraph.css';

const WeeklyVisitorsChart = () => {
  // Fetch visitor data from Redux
  const thisWeekVisitors = useSelector((state) => state.dashboard?.data?.thisWeekVisitors);

  // If data is undefined, show loading
  if (!thisWeekVisitors || thisWeekVisitors.length === 0) {
    return (
      <Card className="weekly-visitors-card" title="Visitor Statistics This Week" bordered={false}>
        <p>Loading data...</p>
      </Card>
    );
  }

  // Define specific colors for each day
  const colorMap = {
    Sunday: '#f0e68c',    // Khaki
    Monday: '#ff4d4d',    // Red
    Tuesday: '#32cd32',   // Green
    Wednesday: '#ffa500', // Orange
    Thursday: '#1e90ff',  // Blue
    Friday: '#ff69b4',    // Pink
    Saturday: '#8a2be2',  // Purple
  };

  // Days of the week in order
  const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  // Prepare data for the BarChart
  const data = daysOfWeek.map((day, index) => {
    // Find the visitor data for this day
    const visitorData = thisWeekVisitors.find((item) => {
      // Convert timestamp to day index (0 - Sunday, 1 - Monday, etc.)
      const dayIndex = new Date(item.date).getDay();
      return dayIndex === index;
    });

    return {
      day,
      visitors: visitorData?.totalVisitors || 0, // Default to 0 if no data
      color: colorMap[day], // Assign color for each day
    };
  });

  // Custom Tooltip Component
  const CustomTooltip = ({ payload, label }) => {
    if (payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <p>{`${label}: ${payload[0].value}`}</p> {/* Removed "Visitors" from the tooltip */}
        </div>
      );
    }
    return null;
  };

  return (
    <Card className="weekly-visitors-card" title="Visitor Statistics This Week" bordered={false}>
      <ResponsiveContainer width="100%" height={400}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="day" tick={{ fontSize: 14 }} />
          <YAxis
            tick={{ fontSize: 14 }}
            tickCount={6} // Set the number of ticks
            interval={0}
            domain={[0, 10]} // Fixed scale from 0 to 10 for Y-axis
          />
          <Tooltip content={<CustomTooltip />} />
          {/* Removed the Legend */}
          <Bar dataKey="visitors" barSize={40}>
            {data.map((entry) => (
              <Cell key={entry.day} fill={entry.color} /> // Use the color from colorMap for each day
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Card>
  );
};

export default WeeklyVisitorsChart;
